import React, { Fragment } from 'react';
import { Button, Form, FormGroup, Label, Input, Modal, ModalBody, ModalHeader, ModalFooter, Spinner } from 'reactstrap';
import PropTypes from 'prop-types';
import UploadWhitelistConfirmationMessage from './uploadWhitlistConfirmationMessage';
import { maximumUsersUpload } from '../../helpers/constants';

const UploadWhitelistModal = ({
  clearWhitelistState,
  entryAlreadyInWhitelist,
  entryMissingFromOrgList,
  entryPresentInOrgList,
  handleSubmit,
  isSpinner,
  newWhiteList,
  toggleImportModal,
  toggleImportModalFlag,
  uploadFile
}) => {
  const isShowConfirmationMessage = Boolean(
    entryAlreadyInWhitelist.length || entryMissingFromOrgList.length || entryPresentInOrgList.length
  );

  return (
    <Fragment>
      <Modal isOpen={toggleImportModalFlag} labelledBy="upload-whitelist-title" toggle={toggleImportModal}>
        <Form onSubmit={handleSubmit}>
          <ModalHeader id="upload-whitelist-title" title={''}>
            Upload Whitelist
          </ModalHeader>
          <ModalBody>
            {isShowConfirmationMessage ? (
              <UploadWhitelistConfirmationMessage
                entryAlreadyInWhitelist={entryAlreadyInWhitelist}
                entryMissingFromOrgList={entryMissingFromOrgList}
                entryPresentInOrgList={entryPresentInOrgList}
              />
            ) : (
              <div>
                <div>
                  <div className="file-description-header mb-4">
                    <h6 className="modal-title file-description-content">
                      <strong>
                        Please upload a list of users ({maximumUsersUpload} max) to be granted access to the INBDE web
                        application.
                      </strong>{' '}
                      Please make sure that the list is in the <strong>correct format</strong>, otherwise you will not
                      be able to upload it. Examples below indicate the <i>required fields and format of data</i>.
                    </h6>
                  </div>
                  <div className="file-description-examples fs--1">
                    <p className="mb-2">
                      One user per row: the email address in the first column and the role, admin or faculty, in the
                      second. No header row is needed.
                    </p>
                    <table className="table table-sm table-bordered mb-3">
                      <caption className="pt-0 text-600" style={{ captionSide: 'top' }}>
                        CSV list if uploading using Excel
                      </caption>
                      <thead>
                        <tr>
                          <th scope="col">Column A: email address</th>
                          <th scope="col">Column B: role</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>netid1@nyu.edu</td>
                          <td>admin</td>
                        </tr>
                        <tr>
                          <td>netid2@nyu.edu</td>
                          <td>faculty</td>
                        </tr>
                      </tbody>
                    </table>
                    <p className="mb-1">
                      CSV list if uploading using a text editor: one user per line, a comma between the email address
                      and the role.
                    </p>
                    <pre className="bg-100 p-2 mb-0">
                      <code>{'netid1@nyu.edu, admin\nnetid2@nyu.edu, faculty'}</code>
                    </pre>
                  </div>
                </div>
                <hr />
                <FormGroup>
                  <Label htmlFor="user_whitelist">Select the file</Label>
                  <Input
                    type="file"
                    name="file"
                    id="user_whitelist"
                    accept=".csv"
                    onChange={uploadFile}
                    disabled={isSpinner}
                  />
                  <small>Accepted file format(s): .csv only</small>
                </FormGroup>
                <FormGroup check>
                  <Input
                    type="checkbox"
                    name="document_permission"
                    id="whitelist-waiver"
                    required
                    disabled={isSpinner}
                  />
                  <Label htmlFor="whitelist-waiver">
                    I understand that by uploading this list, the included emails will gain access to INBDE.
                  </Label>
                </FormGroup>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={toggleImportModal} disabled={isSpinner}>
              Close
            </Button>
            {isShowConfirmationMessage && (
              <Button color="danger" onClick={clearWhitelistState} disabled={isSpinner}>
                Clear
              </Button>
            )}
            <Button color="primary" type="submit" disabled={!newWhiteList || isSpinner}>
              {isShowConfirmationMessage ? 'Confirm' : 'Upload'}
              {isSpinner && <Spinner size="sm" color="light" className="ml-2" />}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </Fragment>
  );
};

UploadWhitelistModal.propTypes = {
  clearWhitelistState: PropTypes.func.isRequired,
  entryAlreadyInWhitelist: PropTypes.array.isRequired,
  entryMissingFromOrgList: PropTypes.array.isRequired,
  entryPresentInOrgList: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSpinner: PropTypes.bool.isRequired,
  newWhiteList: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  toggleImportModal: PropTypes.func.isRequired,
  toggleImportModalFlag: PropTypes.bool.isRequired,
  uploadFile: PropTypes.func.isRequired
};

export default UploadWhitelistModal;
